import {Vue} from 'ui.vue';
import './infolist.sass';
import InfolistItem from '../../infolist-item/src/infolist-item';

Vue.component('infolist', {

	data() {
		return {
			showedItem: 0,
			sections: []
		};
	},
	
	/* костыль для кириллицы */

	template: `
		<div class="infolist">
			<InfolistItem
				:isShowSubsections="showedItem === index"
				@click.native="toggelShowedItem(index)"
				v-for="(list, index) in sections"
				:list="list"
				:key="index"
			/>
		</div>
	`,
	
	methods: {
		toggelShowedItem(index) {
			this.showedItem = index
			sessionStorage.setItem('showedItem', index);
		}
	},

	created() {
		this.sections = Object.values(window.TECE_INFORMATION.SECTION).filter(item => item.SUBSECTION && item.SUBSECTION.length);
		const showedItem = sessionStorage.getItem('showedItem');
		if (showedItem) {
			this.showedItem = Number(showedItem)
		} else {
			this.showedItem = 0
		}
	},

	components: {
		InfolistItem
	}
});

import { BitrixVue } from 'ui.vue';

const app = BitrixVue.createApp({
  template: '<infolist/>'
});
app.mount('Infolist');
